import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex, Icon, Text } from 'Components/UI/_Legacy'

import arrowLeftLongGlyph from 'Assets/_Legacy/Svg/arrow-left-long.svg'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

export const Container = styled(Flex).attrs({
  pt: [40, 40, 50, 90],
  pb: [50, 60],
})`
  width: 100%;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-color: ${themeGet('colors.calculator.light')};
`

export const Content = styled(Flex)`
  flex-direction: column;
  z-index: 11;
`

export const Top = styled(Flex).attrs({
  flexDirection: ['column', 'column', 'column', 'row'],
  px: LANDING_INLINE_PADDINGS,
})``

export const LeftSide = styled(Flex).attrs({
  width: [1, 1, 1, 1, 70 / 118],
})`
  align-items: center;
`

export const RightSide = styled(Flex).attrs({
  width: [1, 1, 1, 1, 48 / 118],
})`
  flex-direction: column;
  justify-content: center;
`

export const LinkContainer = styled(Flex)`
  margin-top: 19px;
  align-items: center;
  color: ${themeGet('colors.calculator.action')};
  fill: ${themeGet('colors.calculator.action')};

  &:hover {
    color: ${themeGet('colors.calculator.actionHover')};
    fill: ${themeGet('colors.calculator.actionHover')};
  }
`

export const LinkText = styled(Text).attrs({
  fontSize: [16, 16, 18],
})`
  white-space: normal;
  color: inherit !important;
`

export const LinkIcon = styled(Icon).attrs({
  glyph: arrowLeftLongGlyph,
  size: 16,
})`
  margin-left: 10px;
  transform: rotateZ(180deg);
`

export const Bottom = styled(Flex).attrs({
  mt: [45, 60, 80],
  height: [310, 350],
})`
  width: 100%;
  position: relative;
`

export const Scroll = styled(Text).attrs({
  fontSize: ['0px', '0px', 13],
})`
  white-space: nowrap;
  position: absolute;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1px;
  bottom: 0;
  left: -53px;
  writing-mode: vertical-rl;
  transform: rotateZ(180deg);
`
export const DotsContainer = styled(Flex).attrs({
  display: ['none', 'none', 'flex'],
})`
  position: absolute;
  top: -32px;
  left: -32px;
`

export const StyledButton = styled.button`
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
  padding: 0;
`
